
 
 function Card (props:any){
    return(
        <div >
            <div className="mt-8 flex flex-col items-center gap-4 justify-center w-80 h-72 rounded-3xl bg-[#1A1B23] text-white">
                <img src={props.image} className="flex justify-center w-16 " alt="" />
                <h2 className="text-2xl font-bold">{props.title}</h2>
                <p className="px-6 text-center text-gray-500">{props.text}</p>
                <h4 className="text-purple-400">Click me ➜</h4>
            </div>
      
        </div>

    )
}

export default Card